import React, { FC } from 'react';
import styled from 'styled-components';
import { Profile } from '../index';
import { ProfileFormData } from './ProfileForm';
import { ProfileSettingsContactFormCard } from './ProfileSettingsContactFormCard';

interface Props {
  onSubmit: (values: ProfileFormData) => void;
  profile: Profile;
}

const Styles = styled.div``;

export const ProfileSettingsContact: FC<Props> = ({ onSubmit, profile }): JSX.Element => {
  return (
    <Styles>
      <div className="contact-settings-card">
        <ProfileSettingsContactFormCard onSubmit={onSubmit} profile={profile} />
      </div>
    </Styles>
  );
};
